import PropTypes from "prop-types";
import { Checkbox } from "primereact/checkbox";
import { classNames } from "primereact/utils";

export default function FormCheckbox(props) {
  const {
    className = "",
    isControl = true,
    setting: {
      Controller,
      control,
      setValue,
      trigger,
      isSubmitted,
      isEdit = true,
    } = {},
    data: {
      name,
      label,
      value,
      elValue,
      elChange,
      type = "multi",
      disabled = false,
      isWrap = false,
    },
  } = props;

  const onChange = (e, field) => {
    const {
      checked,
      target: { name, value },
    } = e;
    let allValue = isControl ? field.value : elValue;

    if (type === "multi") {
      allValue = allValue ?? [];
      if (checked) allValue.push(e.value);
      else allValue.splice(allValue.indexOf(value), 1);
    } else if (type === "checked") {
      allValue = checked;
    }

    if (isControl) {
      setValue(name, allValue);

      if (isSubmitted) {
        trigger();
      } else {
        trigger(name);
      }
    } else {
      elChange({ name, value, options: props.data });
    }
  };

  const renderElement = ({ field, fieldState } = {}) => {
    const checkedValue = isControl ? field.value : elValue;

    return (
      <div
        className={classNames(
          className,
          "relative flex align-items-center min-w-220 ml-1 mr-3 my-2"
        )}
      >
        <Checkbox
          inputId={`${name}_${value}`}
          className={classNames({
            "p-invalid": isControl && fieldState?.invalid,
          })}
          name={name}
          value={value}
          checked={
            type === "multi"
              ? (checkedValue ?? []).includes(value)
              : checkedValue
          }
          onChange={(e) => onChange(e, field)}
          disabled={!isEdit || disabled}
        />
        <label
          htmlFor={`${name}_${value}`}
          className={classNames("ml-1", {
            "white-space-nowrap": !isWrap,
          })}
        >
          {label}
        </label>
      </div>
    );
  };

  return (
    <>
      {isControl ? (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            renderElement({ field, fieldState })
          }
        />
      ) : (
        renderElement()
      )}
    </>
  );
}

FormCheckbox.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    disabled: PropTypes.bool,
    elChange: PropTypes.func,
    elValue: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
    isWrap: PropTypes.bool,
    label: PropTypes.node,
    name: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
  }).isRequired,
  isControl: PropTypes.bool,
  setting: PropTypes.shape({
    control: PropTypes.object,
    Controller: PropTypes.elementType,
    isEdit: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    setValue: PropTypes.func,
    trigger: PropTypes.func,
  }),
};
